//import { Grid } from "@mui/material";
import Select from "../select";
import TextField from "../TextField";
import { styled } from "@mui/material/styles";

// import { useFormikContext } from "formik";

const Container = styled("div")`
  background-color: ${(props) => props.theme.palette.background.paper};
  border-radius: ${(props) => props.theme.shape.borderRadiusGeneral}px;
  height: 2.23020625rem;
  display: flex;
  align-items: center;
  justify-self: flex-end;
`;

const Search = ({ items = [], ...props }) => {
  // const { values, setFieldValue } = useFormikContext();
  return (
    <Container>
      <TextField noWrap name="searchValue" placeholder="search" search={true} />

      {"|"}

      <Select
        isSimpleValue={false}
        noWrap
        search={true}
        label=""
        items={[...items]}
        name="column"
      />
    </Container>
  );
};

export default Search;
